import { z } from "zod";
export const LocationSchema = z.object({
  country: z.string().optional().nullable(),
  id: z.string().or(z.number()).optional().nullable(),
  type: z.string().optional().nullable(),
  iata: z.string().optional().nullable(),
  latitude: z.number().or(z.string()),
  longitude: z.number().or(z.string()),
  value: z.string()
});